<template>
  <BaseListCard
    title="Specific Terms - Water Quality Protection Areas"
    entityTitle="Water Quality Protection Areas"
    :parentId="instrumentId"
    :parentTitle="'Instrument'"
    :options="{}"
    :entities="entities"
    :entitiesLoading="entitiesLoading"
    :deleteEntity="deleteEntity"
    :emptyEntity="emptyEntity"
    :entitySort="entitySort"
    ref="baseCard"
    >
    <template v-slot:addForm="{ newEntity, options, stopAdding, entityCreated }">
      <ProtectionAreaForm
        :initialProtectionArea="newEntity"
        @closeForm="stopAdding">
      </ProtectionAreaForm>
    </template>
    <template v-slot:editForm="{ entity, options, stopEditing, entityUpdated }">
      <ProtectionAreaForm
        :initialProtectionArea="entity"
        @closeForm="stopEditing">
      </ProtectionAreaForm>
    </template>
    <template v-slot:entityDetails=" { entity }">
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="list-header">
            Special Condition Area ID
          </div>
          <div class="list-details">
            {{ entity.globalId }}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="list-header">
            Feature Name
          </div>
          <div class="list-details">
            {{ entity.name }}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="list-header">
            Feature Type
          </div>
          <div class="list-details">
            {{ getFeatureTypeName(entity.featureTypeId) }}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="list-header">
            Feature Geometry 
          </div>
          <div class="list-details">
            {{ getGeometryTypeName(entity.geometryTypeId) }}
          </div>
        </div>

      </div>
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="list-header">
            Feature Length (ft)
          </div>
          <div class="list-details">
            {{ entity.featureLength | numberFormat }}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="list-header">
            Buffer Width (ft)
          </div>
          <div class="list-details">
            {{ entity.bufferWidth | numberFormat }}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="list-header">
            Buffer Sides
          </div>
          <div class="list-details">
            {{ entity.bufferRestrictionId ? getBufferRestrictionName(entity.bufferRestrictionId) : 'None' }}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="list-header">
            Livestock Restriction
          </div>
          <div class="list-details">
            {{ getLivestockRestrictionName(entity.livestockRestrictionId) }}
          </div>
        </div>

      </div>
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="list-header">
            Timber Harvest Restriction
          </div>
          <div class="list-details">
            {{ getTimberHarvestRestrictionName(entity.timberHarvestRestrictionId) }}
          </div>
        </div>
      </div>
    </template>
  </BaseListCard>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BaseListCard from '../common/BaseListCard.vue';
import CollapseParent from '@/mixins/CollapseParent';
import ProtectionAreaForm from './ProtectionAreaForm.vue';
import { EntityModules, LookupModules } from '@/store/moduleConfig';

export default {
  name: 'ProtectionAreaCard',
  props: [
    'instrumentId',
  ],
  mixins: [CollapseParent],
  components: {
    BaseListCard,
    ProtectionAreaForm,
  },
  computed: {
    ...mapState(EntityModules.WATER_QUALITY_PROTECTION_AREA.namespace, {
      entities: state => state.entities,
      entitiesLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.FEATURE_TYPES.namespace, {
      getFeatureTypeName: 'getName',
    }),
    ...mapGetters(LookupModules.GEOMETRY_TYPES.namespace, {
      getGeometryTypeName: 'getName',
    }),
    ...mapGetters(LookupModules.BUFFER_RESTRICTIONS.namespace, {
      getBufferRestrictionName: 'getName',
    }),
    ...mapGetters(LookupModules.LIVESTOCK_RESTRICTIONS.namespace, {
      getLivestockRestrictionName: 'getName',
    }),
    ...mapGetters(LookupModules.TIMBER_HARVEST_RESTRICTIONS.namespace, {
      getTimberHarvestRestrictionName: 'getName',
    }),
  },
  created() {
    this.$store.dispatch(`${LookupModules.FEATURE_TYPES.namespace}/fetchOptions`,
      LookupModules.FEATURE_TYPES.url);
    this.$store.dispatch(`${LookupModules.GEOMETRY_TYPES.namespace}/fetchOptions`,
      LookupModules.GEOMETRY_TYPES.url);
    this.$store.dispatch(`${LookupModules.BUFFER_RESTRICTIONS.namespace}/fetchOptions`,
      LookupModules.BUFFER_RESTRICTIONS.url);
    this.$store.dispatch(`${LookupModules.LIVESTOCK_RESTRICTIONS.namespace}/fetchOptions`,
      LookupModules.LIVESTOCK_RESTRICTIONS.url);
    this.$store.dispatch(`${LookupModules.TIMBER_HARVEST_RESTRICTIONS.namespace}/fetchOptions`,
      LookupModules.TIMBER_HARVEST_RESTRICTIONS.url);
  },
  methods: {
    entitySort(a, b) {
      return (b.id - a.id);
    },
    emptyEntity(instrumentId) {
      return {
        instrumentId,
        name: '',
        featureTypeId: '',
        geometryTypeId: '',
        featureLength: null,
        bufferWidth: null,
        bufferRestrictionId: '',
        livestockRestrictionId: '',
        timberHarvestRestrictionId: '1',
      };
    },
    deleteEntity(entity) {
      this.$store.dispatch(
        `${EntityModules.WATER_QUALITY_PROTECTION_AREA.namespace}/deleteEntity`, {
          entityType: EntityModules.WATER_QUALITY_PROTECTION_AREA.namespace,
          entity,
        },
      );
    },
  },
};
</script>
